import {Device} from '../../base/Device';
import { WOW } from 'wowjs';
import {UAnimateContainer, UAnimate} from 'vue-wow';
/**
 * @author yeyuchao
 * @description what the Elab is doing.
 */
const windowsWidth =window.screen.width;
const windowsHeight = window.screen.height;
export default {
  data() {
    return {
      windowsWidth:windowsWidth,
      windowsHeight:windowsHeight,
      device:null,
      deviceMobile:null,
    };
  },
  components: {
    UAnimateContainer,
    UAnimate
  },
  mounted() {
  },
  created() {
    this.device = new Device();
    if(this.device.phone){
      this.deviceMobile = true;
    }
    if(!window.loadComplete){
      this.$router.push('/');
      return
    }
  },
  methods:{
    getTarget() {
      return this.$el;
    },
    navigateToDaMai(){
      this.$router.push('/elabDamai');
    },
    navigateToFeatureDo(){
      this.$router.push('/feature');
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/elabDo/elabDo.js